import React, { Component } from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, OverlayView } from 'react-google-maps'
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import ProfilePicture from '../components/generic/ProfilePicture'

import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'
import StandaloneSearchBox from 'react-google-maps/lib/components/places/StandaloneSearchBox'
import { FilterBar, /*SelectTreeFilterItem, LocationFilterItem,*/ DateFilterItem } from '../components/generic/filter'
import { DashboardGraph } from '../components/generic/graphs'
import MetricCard from '../components/generic/MetricCard'
import DashboardCard from '../components/generic/DashboardCard'
import { DashboardGrid, DashboardRow } from '../components/generic/grid'
import { Card, Col, Row} from '../components/generic'
import OverlayViewMarker from '../components/generic/OverlayViewMarker'
import { processSalesInteractions } from '../lib/salesStatistics'
import PlaybackModal from '../components/recordings/PlaybackModal'

import moment from 'moment'

import SalesInteractionFeed from '../components/sales-interactions/SalesInteractionFeed'
import TopNCard from '../components/generic/TopNCard'

import Numeral from 'numeral'
import 'numeral/locales/en-za.js'
import PropTypes from 'prop-types'
/* global google */

// switch between locales
Numeral.locale('en-za')

const getSalesInteractions = gql`
  {
    salesinteractions(limit: 10000) {
      id
      location {
        latitude
        longitude
      }
      result
      salesPerson {
        id
        first
        last
        photo {
          id
          url
        }
      }
      recording {
        id
        url
      }
      funeral {
        id
        currentPremiumTotal
      }
      timestamp
    }
    salesteams {
      id
      name
      managerOfTeam {
        id
        first
        last
      }
      teams {
        id
      }
      members {
        id
        first
        last
      }
    }
    targets {
      metric
      frequency
      level
      value
    }
  }
`

const subscribeToSalesInteractions = gql`
  subscription {
    salesinteractionCreated {
      id
      location {
        latitude
        longitude
      }
      result
      salesPerson {
        id
        first
        last
      }
      recording {
        id
        url
      }
      funeral {
        id
        currentPremiumTotal
      }
      timestamp
    }
  }
`

const targetsToGoals = (targets) => {
  const result = {}
  targets && targets.forEach(target => {
    if (target.level === 'SALES_PERSON') {
      if (!result[target.metric]) {result[target.metric] = {} }
      result[target.metric][target.frequency] = target.value
    }
  })
  return result
}

const startEndActivity = salesActivities => {
  let start, end

  salesActivities.forEach(salesActivity => {
    if (!start || salesActivity.timestamp > start) {
      start = salesActivity.timestamp
    }
    if (!end || salesActivity.timestamp < end) {
      end = salesActivity.timestamp
    }
  })

  return {
    start,
    end
  }
}
const teamTreeNode = (team, exclude = []) => {
  const node = [
    {
      label: `${team.managerOfTeam.first} ${team.managerOfTeam.last} (Manager)`,
      value: team.managerOfTeam.id
    }
  ]
  team.members.filter(member => !exclude.includes(member.id)).forEach(member => {
    node.push({
      label: `${member.first} ${member.last}`,
      value: member.id
    })
  })
  return node
}

const buildFilterNodeTree = (nodes, children, exclude) => {
  return children.map(id => {
    const child = nodes[id]
    if (child.teams.length > 0) {
      return {
        label: child.name,
        value: child.id,
        children: [
          ...teamTreeNode(child, exclude),
          ...buildFilterNodeTree(nodes, child.teams.map(team => team.id), exclude)
        ]
      }
    } else {
      return {
        label: child.name,
        value: child.id,
        children: teamTreeNode(child, exclude)
      }
    }
  })
}

const calculateFilterName = (salesTeamNodes, rootNodes, filterSelected) => {
  let filterName = ''
  let teamName
  let fullMatches = 0
  rootNodes.forEach(id => {
    let memberName
    const salesTeam = salesTeamNodes[id]
    const hasAllMembers =
      !salesTeam.members ||
      salesTeam.members.reduce((result, member) => {
        if (filterSelected.includes(member.id)) {
          if (!memberName) {
            memberName = `${member.first} ${member.last}`
          } else {
            memberName = 'Multiple sales people'
          }
          return result
        } else {
          return false
        }
      }, true)
    const hasManager = filterSelected.includes(salesTeam.managerOfTeam.id)
    if (hasManager) {
      if (!memberName) {
        memberName = `${salesTeam.managerOfTeam.first} ${salesTeam.managerOfTeam.last}`
      } else {
        memberName = 'Multiple sales people'
      }
    }
    if (hasAllMembers && hasManager) {
      if (salesTeam.teams.length > 0) {
        const result = calculateFilterName(salesTeamNodes, salesTeam.teams.map(team => team.id), filterSelected)
        if (result === 'All Sales Teams') {
          fullMatches += 1
          if (!teamName) {
            teamName = salesTeam.name
          } else {
            teamName = 'Multiple sales teams'
          }
        }
      } else {
        fullMatches += 1
        if (!teamName) {
          teamName = salesTeam.name
        } else {
          teamName = 'Multiple sales teams'
        }
      }
    } else {
      filterName = memberName
    }
  })
  if (fullMatches === rootNodes.length) {
    return 'All Sales Teams'
  }
  return filterName || teamName || 'All Sales Teams'
}

const processSalesTeams = (salesTeams, selected = ['all'], loading) => {
  if (loading) {
    return {
      filterNodes: [
        {
          label: 'All Sales Teams',
          value: 'all'
        }
      ],
      rootNodes: [],
      filterSelected: []
    }
  }

  const salesTeamNodes = {}
  const isChild = []
  const isManager = []
  const filterSelected = []
  salesTeams.forEach(salesTeam => {
    salesTeamNodes[salesTeam.id] = salesTeam
    if (salesTeam.teams.length > 0) {
      salesTeam.teams.forEach(team => {
        isChild.push(team.id)
      })
      isManager.push(salesTeam.managerOfTeam.id)
    }
    if (selected.includes(salesTeam.managerOfTeam.id) || selected.includes('all')) {
      filterSelected.push(salesTeam.managerOfTeam.id)
    }
    salesTeam.members.forEach(member => {
      if (selected.includes(member.id) || selected.includes('all') || selected.includes(salesTeam.id)) {
        filterSelected.push(member.id)
      }
    })
  })

  const rootNodes = Object.keys(salesTeamNodes).filter(id => !isChild.includes(id))

  const filterName = calculateFilterName(salesTeamNodes, rootNodes, filterSelected)

  const filterNodes = [
    {
      label: 'All Sales Teams',
      value: 'all',
      children: buildFilterNodeTree(salesTeamNodes, rootNodes, isManager)
    }
  ]
  return {
    filterNodes,
    filterName,
    filterSelected
  }
}

const processSalesPeopleStats = salesPersonStats => {
  let activeSalesPeopleStats = {}
  Object.keys(salesPersonStats)
    .filter(id => id !== '-1')
    .map(id => {
      const diff = moment().diff(moment(salesPersonStats[id].lastTimestamp), 'minutes')
      if (diff <= 15) {
        activeSalesPeopleStats[id] = salesPersonStats[id]
      }
    })
  return {
    activeSalesPeopleStats
  }
}

const calculateSalesPeopleStats = (salesInteractions, salesPeople) => {
  const salesPeopleStats = {}
  Object.keys(salesPeople).forEach(salesPersonId => {
    const {
      totalSales,
      totalHours,
      totalInteractions,
      lastTimestamp,
      lastLocation,
      salesPerDay,
      salesPerHour,
      premiumsPerDay
    } = processSalesInteractions(
      salesInteractions.filter(
        salesInteraction =>
          (salesInteraction.salesPerson && salesInteraction.salesPerson.id === salesPersonId) ||
          (!salesInteraction.salesPerson && salesPersonId == -1)
      )
    )
    salesPeopleStats[salesPersonId] = {
      totalSales,
      totalHours,
      totalInteractions,
      totalUnsuccessful: totalInteractions - totalSales,
      successRate: totalSales / totalHours,
      lastTimestamp,
      lastLocation,
      salesPerDay,
      salesPerHour,
      premiumsPerDay
    }
  })
  return salesPeopleStats
}

const objToArray = (obj, keyName) =>
  Object.keys(obj)
    .sort((a, b) => (a <= b ? -1 : 1))
    .map(key => ({ [keyName]: key, ...obj[key] }))

const combineDataToArray = (data, sub, subKeyName, ignore = ['-1']) => {
  const result = {}
  Object.keys(data).forEach(key => {
    if (!ignore.includes(key)) {
      Object.keys(data[key][sub]).forEach(key2 => {
        if (!result[key2]) {
          result[key2] = {}
        }
        result[key2][key] = data[key][sub][key2]
      })
    }
  })
  return objToArray(result, 'day')
}

const cumulativeData = (points, pointKey, valueKey, cumulativeKey, startAt = 0) => {
  let total = startAt || 0
  const result = []
  Object.keys(points)
    .sort((a, b) => (a <= b ? -1 : 1))
    .forEach(key => {
      total += points[key] || 0
      result.push({
        [valueKey]: points[key],
        [cumulativeKey]: total,
        [pointKey]: key
      })
    })
  return result
}

const getCenterLocation = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 30000,
        maximumAge: 600000
      })
    } else {
      resolve({ latitude: -34.033264, longitude: 23.049452 })
    }
  })
}

const SalesPersonItem = ({ data, metric, onItemPress, goal }) => (
  <div key={data.id} style={{ flexGrow: 1, flexDirection: 'row', display: 'flex' }}>
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div>
        <ProfilePicture photo={data.photo} size={20} circle style={{ marginTop: 2, marginBottom: 2, marginRight: 7 }} />
        <a href="#" onClick={() => onItemPress && onItemPress(data)}><span style={{ fontSize: 16 }}>{`${data.first} ${data.last}`}</span></a>
      </div>
    </div>
    <div
      style={{
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end'
      }}
    >
      <div style={{ paddingTop: 3, paddingRight: 3, fontSize: 16 }}>{metric.toFixed(2)}</div>
      {goal && <div><i className={`fa ${goal > metric ? "fa-exclamation-triange" : "fa-check-circle" }`} style={{ color: goal > metric ? "red" : "green" }} /></div>}
    </div>
  </div>
)


class Campaigns extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedSalesPeople: [],
      startDate: moment().subtract(1, 'month'),
      endDate: null,
      centerMap: null,
      showPlaybackModal: false,
      playbackTimestamp: null
    }
  }

  componentWillMount() {
    /*!this.centerMap &&
      getCenterLocation().then(location => {
        this.centerMap = location.coords;
        this.setState({ fetchingLocation: false });
      });*/
    this.props.data.subscribeToMore({
      document: subscribeToSalesInteractions,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev
        }
        const newSalesInteraction = subscriptionData.data.salesinteractionCreated
        // don't double add the message
        if (!prev.salesinteractions.find(d => d.id === newSalesInteraction.id)) {
          return Object.assign({}, prev, {
            salesinteractions: [...prev.salesinteractions, newSalesInteraction],
            salesteams: this.props.data.salesteams,
            targets: this.props.targets
          })
        } else {
          return prev
        }
      }
    })
  }

  componentDidMount() {
    this.handleGotoCurrentLocation()
  }

  handleGotoCurrentLocation = () => {
    getCenterLocation().then(location => {
      this.setState({ centerMap: location.coords })
    })
  }

  render() {
    if (this.props.data.error) {
      return <h1>An error occurred</h1>
    } else {
      const goals = targetsToGoals(this.props.data.targets)
      const { filterNodes, filterName, filterSelected } = processSalesTeams(
        this.props.data.salesteams,
        this.state.selectedSalesPeople,
        this.props.data.loading
      )
      const filteredSalesInteractions = this.props.data.loading
        ? []
        : this.props.data.salesinteractions.filter(
            d =>
              (!this.state.startDate ||
                moment(d.timestamp).format('YYYYMMDD') >= moment(this.state.startDate).format('YYYYMMDD')) &&
              (!this.state.endDate ||
                moment(d.timestamp).format('YYYYMMDD') <= moment(this.state.endDate).format('YYYYMMDD')) &&
              (this.state.selectedSalesPeople.length === 0 || this.state.selectedSalesPeople.includes(d.salesPerson.id))
          )
      const {
        categoryPoints,
        salesPeople,
        totalSales,
        totalHours,
        totalInteractions,
        totalPremiums,
        salesPerDay,
        premiumsPerDay
      } = processSalesInteractions(filteredSalesInteractions)
      const salesPeopleStats = calculateSalesPeopleStats(filteredSalesInteractions, salesPeople)
      const { activeSalesPeopleStats } = processSalesPeopleStats(salesPeopleStats)

      return (
        <div className="MapDisplay" style={{ backgroundColor: '#e8e8e8' }}>
          {
            this.state.showPlaybackModal && <PlaybackModal id={this.state.showPlaybackId} show title={this.state.playbackTimestamp} onClosePlaybackModal={() => this.setState({ showPlaybackModal: false })} />
          }
          <FilterBar>
            
            <DateFilterItem
              name="duration"
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              onDatesChange={(startDate, endDate) => {
                let date1
                let date2
                if (startDate && !endDate) {
                  if (startDate < this.state.startDate) {
                    date1 = startDate
                    date2 = this.state.startDate
                  } else {
                    date1 = startDate
                    date2 = this.state.endDate || moment()
                  }
                } else {
                  date1 = startDate || this.state.startDate
                  date2 = endDate || this.state.endDate || moment()
                }
                this.setState({ startDate: date1 < date2 ? date1 : date2, endDate: date1 > date2 ? date1 : date2 })
              }}
              loading={this.props.data.loading}
              right
            />
          </FilterBar>
          <Card>
            <DashboardRow>
              <MetricCard
                size={12}
                label={'Sales People'}
                value={!this.props.data.loading && Object.keys(salesPeople).length - 1}
              />
              <MetricCard size={12} label={'Successful Sales'} value={totalSales} />
              <MetricCard
                size={12}
                label={'Total Premiums Sold'}
                value={!this.props.data.loading && Numeral(totalPremiums).format('$black##,###0')}
              />
              <MetricCard size={12} label={'Hours Worked'} value={!this.props.data.loading && totalHours.toFixed(2)} />
              <MetricCard
                size={12} 
                label={'Premiums per Hour'}
                value={!this.props.data.loading && Numeral(totalPremiums / totalHours).format('$black##,##0.##')}
                warning={totalPremiums && totalHours && (totalPremiums / totalHours) < goals && goals['premiums'] ? goals['premiums']['HOURLY'] : 0}
              />
              <MetricCard
                size={12}
                label={'Interactions per Hour'}
                value={!this.props.data.loading && (totalInteractions / totalHours).toFixed(2)}
              />
            </DashboardRow>
            <DashboardRow>
              <MetricCard
                size={12}
                label={'Active Sales People'}
                value={!this.props.data.loading && Object.keys(activeSalesPeopleStats).length}
              />
              <MetricCard
              size={12}
                label={'Success Rate'}
                value={!this.props.data.loading && (totalSales / totalHours).toFixed(2)}
                warning={totalSales && totalHours && (totalSales / totalHours) <  goals && goals['sales'] ? goals['sales']['HOURLY'] : 0}
              />
              <MetricCard
              size={12}
                label={'Unsuccessful Sales'}
                value={!this.props.data.loading && totalInteractions - totalSales}
              />
              <MetricCard
              size={12}
                label={'Interactions per Sale'}
                value={!this.props.data.loading && (totalInteractions / totalSales).toFixed(2)}
              />
              <MetricCard
              size={12}
                label={'Premiums Per Interaction'}
                value={!this.props.data.loading && Numeral(totalPremiums / totalInteractions).format('$black##,##0.##')}
              />
              <MetricCard
              size={12}
                label={'Average Premium Per Sale'}
                value={!this.props.data.loading && Numeral(totalPremiums / totalSales).format('$black##,##0.##')}
              />
            </DashboardRow>
            <DashboardRow>
              <DashboardGraph
                title={'Sales Person New Premiums Per Day'}
                size={12}
                data={!this.props.data.loading && combineDataToArray(salesPeopleStats, 'salesPerDay', 'day')}
                x={'day'}
                y={Object.keys(salesPeople).filter(id => id !== '-1')}
                label={y => `${salesPeople[y].first} ${salesPeople[y].last}`}
                goalLine={!this.props.data.loading && goals && goals['sales'] && goals['sales']['DAILY']}
              />
              <DashboardGraph
                title={'Daily Sales'}
                size={12}
                data={!this.props.data.loading && cumulativeData(salesPerDay, 'day', 'Daily', 'Cumulative')}
                x={'day'}
                y={['Daily', 'Cumulative']}
                goalLine={!this.props.data.loading && goals && goals['sales'] && goals['sales']['DAILY'] * Object.keys(salesPeople).length}
              />
              <DashboardGraph
                title={'Sales Person Sales Value Per Day'}
                size={12}
                data={!this.props.data.loading && combineDataToArray(salesPeopleStats, 'premiumsPerDay', 'day')}
                x={'day'}
                y={Object.keys(salesPeople).filter(id => id !== '-1')}
                label={y => `${salesPeople[y].first} ${salesPeople[y].last}`}
                goalLine={!this.props.data.loading && goals && goals['premiums'] && goals['premiums']['DAILY']}
              />
              <DashboardGraph
                title={'Daily Sales Value'}
                size={12}
                data={!this.props.data.loading && cumulativeData(premiumsPerDay, 'day', 'Daily', 'Cumulative')}
                x={'day'}
                y={['Daily', 'Cumulative']}
                goalLine={!this.props.data.loading && goals && goals['premiums'] && (goals['premiums']['DAILY'] * Object.keys(salesPeople).length)}
              />
            </DashboardRow>
            <DashboardRow>
              <SalesInteractionFeed
                salesInteractions={!this.props.data.loading && filteredSalesInteractions}
                limit={15}
                onSalesPersonPress={id => this.setState({ selectedSalesPeople: [id] })}
                onLocationPress={customLocation =>
                  this.setState({
                    centerMap: { latitude: customLocation.latitude, longitude: customLocation.longitude }
                  })
                }
                onPlaybackPress={(salesInteraction, timestamp) =>  this.setState({ playbackTimestamp: timestamp, showPlaybackModal: !this.state.showPlaybackModal, showPlaybackId: salesInteraction.id })}
              />
            </DashboardRow>
          </Card>
          <div style={{ height: '100px' }} />
        </div>
      )
    }
  }
}

Campaigns = graphql(getSalesInteractions, {
  options: { fetchPolicy: 'cache-first' }
})(Campaigns)

export default Campaigns
